<template>
	<div>
		<buttonlist @help="help" @opentable="opentable" @search="search" @reflash="reflash" @exps="exps" @imp="impt" @del="del" ref="SetBtn"></buttonlist>
		<wTable
				:data="dataSet"
				:loading="loading"
				:header="tableHeader"
				queryData="SalMonthCountImportView"
				:filter_thousandth="['Money']"
				@handleSelectionChange="handleSelectionChange"
				:option="tableOption"
				ref="singleTable">

		</wTable>
		<el-row class="page">
			<el-col :span="18">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-sizes="[100, 200, 300, 400]"
					:page-size="pageSize"
					:pager-count="5"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</el-col>
			<el-col :span="6">
				<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
			</el-col>
		</el-row>
		<!-- </el-tabs> -->
		<serce :isVisible="isVisible" queryData="SalMonthCountImportView" ref="ser" @getser="serclick"></serce>
		<!-- 改变表格顺序 -->
		<ctable :isVisible="false" :title="$t('getapi[12306]')" queryData="SalMonthCountImportView" :tabNo="SelectIndexs" ref="ctab" @getctab="sortclick"></ctable>

	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'3_salmonthcount',
    computed: {
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight3- Common.reduceTableHeight3,
                maxHeight: this.$windowSize.tableHeight3- Common.reduceTableHeight3,
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
			dialogVisible: false, //时间选择弹框
			dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: this.$http.getPageSize('3_salmonthcount'), // 当前页数据量
			SelectIndexs: '0', //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			isShowEdit: false, // 是否显示编辑页面
			tableHeader: [],
			selectData: [],
            scrollTop:0,
		};
	},
    watch: {
        dataSet: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(that.SelectIndexs)
            })
        },
    },
	mounted: function() {
		let that = this;
		that.userData = sessionStorage.getItem('userData');
		that.authority();
		that.colsort();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
		colsort(){
			let that = this;
			that.$loadviewfields.Fileds('SalMonthCountImportView',that.SelectIndexs,PFileds=>{
                that.tableHeader=PFileds;
			});
		},
		sortclick(val){
			if(val==1){
				this.colsort();
			}
		},
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[12306]"),this.$t("getapi[3846]"));
        },
		//type 1 一览权限 、2 编辑界面权限
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
            that.$refs.SetBtn.SetOneBtnEnable('ctabel',true);
            that.$refs.SetBtn.SetButtonEnable('search,refresh,export,import');
            if(that.selectData.length >0){
                that.$refs.SetBtn.SetOneBtnEnable('del', true)
            } else {
                that.$refs.SetBtn.SetOneBtnEnable('del', false)
            }
		},
		btnauthority() {
			let that = this;
		},
		handleSelectionChange(val) {
			let that = this;
            that.selectData = []
			that.selectData = val
			that.authority()
		},
		handleSizeChange(val) {
			this.pageSize = val;
            this.$http.savePageSize('3_salmonthcount',val)
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},
		// 查询
		search() {
			let that = this;
			that.isVisible = true;
			that.pageIndex=1;
			that.$refs.ser.clearInput(that.isVisible, 'SalMonthCountImportView');
		},
		// 修改表格顺序
		opentable(){
			this.$refs.ctab.clearInputs(true);
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
            that.pageIndex = 1
			that.isVisible = false;
            that.getView();
		},
        tabclick(tab){
            let that = this;
            console.log(tab.name)
            that.SelectIndexs = tab.name;
            that.$nextTick(function(){
                that.$processdata.initForm(tab.name)
            });
            that.colsort();
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				Param: datac
			};
            that.$http.urlpost('/Finance/FrmSaleInvoice/Sal_MonthCountImportList', data, function(res) {
                if (res.Success == 1) {
                    that.dataSet = res.DataContent;
                    that.total = res.Totals;
                    that.loading = false;
                    that.DbTbNames = res.DbTbNames;
                }
                that.authority();
            });
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
		del(){
			let that = this;
            this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                confirmButtonText: that.$t('getapi[1146]'),
                cancelButtonText: that.$t('getapi[2054]'),
                type: 'warning'
            })
                .then(() => {
                    let parm = that.selectData
                    that.$refs.SetBtn.SetOneBtnEnable('del', false);
                    that.$http.urlpost('/Finance/FrmSaleInvoice/DeleteSal_MonthCountImportTransaction', parm, function (res) {
                        that.$refs.SetBtn.SetOneBtnEnable('del', true);
                        if (res.Success == 1) {
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                            that.getView();
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: that.$t('getapi[8574]')
                    });
                });

		},
		// 导出
		exps() {
            let that = this;
            let datac = [];
            for (let i = 0; i < that.queryData.length; i++) {
                datac.push({
                    query_Condition: that.queryData[i].query_Condition,
                    query_field_type: that.queryData[i].Query_Field_Type,
                    query_field_name: that.queryData[i].Query_Field_Name,
                    query_sort: that.queryData[i].query_sort,
                    row_sign: that.queryData[i].row_sign
                });
            }
            let parm = {
                query_sign: "SalMonthCountImportView",
                fromname: that.$t('getapi[12306]'),
                SelectIndexs: that.SelectIndexs,
                MultyVer: that.$processdata.getLanguage(),
                Param: datac
            };
            that.$processdata.commonExport(parm)
		},
        impt(){
            let item = {
                label: this.$t("getapi[12309]"),
                name: '3_salmonthcountimp',
                path: '/salmonthcountimp',
                url: '/salmonthcountimp',
                icon: 'video-play'
            };
            this.$router.push({path: '/salmonthcountimp'});
            this.$store.commit('selectMenu', item);
		}
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}

.bbl {
	margin: 0px auto 10px;
	white-space: pre;
	span {
		margin-left: 10px;
		min-width: 70px;
		text-align: left;
		line-height: 20px;
		display: inline-block;
		margin-right: 0px;
	}
}
</style>
